export default __webpack_public_path__ + "static/top-bg-c145a5520b33bfea893b0365b7b0726c.jpeg";